import axios from "axios";
import { apiVariable } from "./apiVariable";

export const fetchCustomerAssets = async (
  token: string | null | undefined,
  customerId: string
) => {
  const guidPart = customerId.split("-").slice(0, 5).join("-");

  const response = await axios.get(
    `${apiVariable}/ownerCompany/${guidPart}/assets`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
